import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    modal: true,
    partners: []
  },
  getters: {
    modal: state => state.modal,
    partners: state => state.partners
  },
  mutations: {
    CHANGE_MODAL: state => {
      state.modal = !state.modal;
    },
    CHANGE_PARTNERS: (state, value) => {
      state.partners = value;
    }
  },
  actions: {
    setPartners(context, payload) {
      context.commit("CHANGE_PARTNERS", payload);
    }
  },
  modules: {}
});
